import React, { FC } from 'react';
import { Body } from '@hover/blueprint';
import { FloatingLabelSelector } from '../ui';

interface INewsYearSelector {
  onClick: (item: string) => void;
  options: string[];
  selectedValue: string;
}

const YearSelector: FC<INewsYearSelector> = ({
  onClick,
  selectedValue,
  options,
}) => (
  <FloatingLabelSelector
    selectedValue={selectedValue}
    width={{ base: '100%', tablet: '159px' }}
    valueProps={{ color: 'primary.900' }}
    setValue={onClick}
    label={
      <Body
        color="neutral.600"
        fontSize="10px"
        fontWeight="bold"
        letterSpacing="0.15em"
      >
        YEAR
      </Body>
    }
    options={options}
  />
);

export default YearSelector;
